import axios from 'axios';

import { Filter } from './Filter';
import { GetToken } from './Session';

export function GetProductCatalogByID(id, q) {
	return axios.get('/api/v1/product_catalogs/' + id + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetProductCatalog(q) {
	return axios.get('/api/v1/product_catalogs' + Filter({ per_page: 200, ...q }), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetProduct(q) {
	return axios.get('/api/v1/products' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function getCatalogImage(q) {
	return axios.get('/api/v1/product_images' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetCertificateOwnerByID(id) {
	return axios.get('/api/v1/certificates/' + id, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function UpdateCertificateOwnerByID(id, data) {
	return axios.patch('/api/v1/certificates/' + id, data, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function CheckNIP(nip) {
	return axios.get('/api/edu.hsi.id/users/' + nip, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export async function UpdateProductStock(data) {
	return axios.post('/api/v1/stock_opname', data, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetSalesSummaryByDate(q) {
	return axios.get('/api/v1/sales_summary_by_date' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetSalesSummaryByDateByCatalog(q) {
	return axios.get('/api/v1/sales_summary_by_date_by_catalog' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}